import { render, staticRenderFns } from "./AppBerichten.vue?vue&type=template&id=89ec9138&scoped=true&"
import script from "./AppBerichten.ts?vue&type=script&lang=ts&"
export * from "./AppBerichten.ts?vue&type=script&lang=ts&"
import style0 from "./AppBerichten.scss?vue&type=style&index=0&id=89ec9138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ec9138",
  null
  
)

export default component.exports